import en from './reporting.en';

const enConfig = { en };

export default enConfig;
